import { api } from '../utils';

export const getLanguages = async () => {
  try {
    return await api('/langs', {}, 'GET', true);
  } catch (e) {
    throw e;
  }
};
